import {IconAlertTriangle} from "@tabler/icons-react";
import PropTypes from "prop-types";
import {useEffect, useState} from "react";

import {useTranslation} from "react-i18next";
import useGetUserWallet from "../../../../hooks/wallet/useGetUserWallet";
import useCurrencyStore from "../../../../store/useCurrency.store";
import styles from "./WithdrawalAmount.module.css";

const WithdrawalAmount = ({setWithdrawalAmount, setIsNextDisabled}) => {
  const {isLoading, balance, getAccountByCurrency} = useGetUserWallet();
  const {selectedCurrency} = useCurrencyStore();
  const [error, setError] = useState("");

  const {t} = useTranslation();

  const currentCurrencyAccount = selectedCurrency ? getAccountByCurrency(selectedCurrency.id) : balance;

  useEffect(() => {
    setIsNextDisabled?.(true);
  }, [setIsNextDisabled]);

  const handleChange = e => {
    const value = e.target.value;
    const numberRegex = /^\d*\.?\d*$/;
    if (value.trim() === "") {
      setError("");
      setIsNextDisabled?.(true);
      return;
    }
    if (!numberRegex.test(value)) {
      setError(t("transferStepsAmountError"));
      setIsNextDisabled?.(true);
      return;
    }
    const amount = e.target.value;
    if (!Number.parseFloat(amount)) {
      setError(t("withdrawalSteps_2_AmountError"));
      setIsNextDisabled?.(true);
      return;
    }
    if (!currentCurrencyAccount) {
      setError(t("widthdrawalSteps_2_Error2"));
      setIsNextDisabled?.(true);
      return;
    }

    if (Number.parseFloat(amount) > currentCurrencyAccount.balance) {
      setError(
        `${t("widthdrawalSteps_2_Error2")} - ${t("currencyName")}: ${t(`currency${selectedCurrency?.id || "VES"}`)}`
      );
      setIsNextDisabled?.(true);
      return;
    }

    const currencyId = selectedCurrency?.id || "VES";
    let minimumAmount = 200;
    if (currencyId === "USD") {
      minimumAmount = 5;
    } else if (currencyId === "USDT") {
      minimumAmount = 5;
    }

    if (Number.parseFloat(amount) < minimumAmount) {
      const currencySymbol = t(`currencySymbol${currencyId}`);
      setError(`${t("widthdrawalSteps_2_Error3").replace("200 Bs", `${minimumAmount} ${currencySymbol}`)}`);
      setIsNextDisabled?.(true);
      return;
    }

    let maximumAmount = 50000;
    if (currencyId === "USD") {
      maximumAmount = 1000;
    } else if (currencyId === "USDT") {
      maximumAmount = 1000;
    }

    if (Number.parseFloat(amount) > maximumAmount) {
      const currencySymbol = t(`currencySymbol${currencyId}`);
      setError(
        `${t("widthdrawalSteps_2_Error4").replace("8.000 Bs", `${maximumAmount.toLocaleString()} ${currencySymbol}`)}`
      );
      setIsNextDisabled?.(true);
      return;
    }

    setWithdrawalAmount(Number.parseFloat(amount));
    setError("");
    setIsNextDisabled?.(false);
  };

  return (
    <div>
      <h4 className={styles.heading}>{t("withdrawalSteps_2_Amount")}</h4>

      {isLoading && (
        <div className={styles.loadingContainer}>
          <div className={styles.spinner} />
        </div>
      )}

      {!isLoading && error && (
        <div className={styles.errorAlert}>
          <IconAlertTriangle
            className={styles.errorIcon}
            size={18}
          />
          <span>{error}</span>
        </div>
      )}

      {!isLoading && (
        <div className={styles.inputWrapper}>
          <div className={styles.inputContainer}>
            <input
              type="text"
              inputMode="decimal"
              pattern="[0-9]*"
              className={styles.amountInput}
              placeholder={t("transferStepsTransferAmountInput")}
              onChange={handleChange}
            />
            <span className={styles.currencySuffix}>
              {selectedCurrency ? t(`currencySymbol${selectedCurrency.id}`) : "Bs."}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

WithdrawalAmount.propTypes = {
  setWithdrawalAmount: PropTypes.func.isRequired,
  setIsNextDisabled: PropTypes.func,
};

export default WithdrawalAmount;
